import { useEffect, useState } from 'react';
import { api, type DayDto } from './api';
import { useApp } from './state';

/** Загружает день ребёнка; перезагружается после изменений и раз в минуту. */
export function useDay(date?: string) {
  const { child, version, fail } = useApp();
  const [data, setData] = useState<DayDto | null>(null);
  const [tick, setTick] = useState(0);

  useEffect(() => {
    const t = setInterval(() => setTick((n) => n + 1), 60000);
    const onVisible = () => document.visibilityState === 'visible' && setTick((n) => n + 1);
    document.addEventListener('visibilitychange', onVisible);
    return () => {
      clearInterval(t);
      document.removeEventListener('visibilitychange', onVisible);
    };
  }, []);

  useEffect(() => {
    let alive = true;
    api.day(child.id, date).then(
      (d) => alive && setData(d),
      (e) => alive && fail(e),
    );
    return () => {
      alive = false;
    };
  }, [child.id, date, version, tick, fail]);

  // При смене даты не показываем старый день.
  return data && (!date || data.date === date) ? data : null;
}
